import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

export default function save({ attributes, clientId }) {
  const { flexClass, carouselSettings } = attributes;

  const biteBlockClass = ['bf_layout', flexClass];

  const blockProps = useBlockProps.save();

  const biteBlockClasses = biteBlockClass.join(' ');
  // set innerBlockProps classes
  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: `${biteBlockClasses}`,
  });

  return (
    <div {...blockProps}>
      <swiper-container
        {...innerBlocksProps}
        navigation={carouselSettings?.navigation === true ? 'true' : 'false'}
        slides-per-view={carouselSettings?.slidesPerView?.xs || 1}
        speed={carouselSettings?.speed == null ? 500 : carouselSettings.speed}
        css-mode={carouselSettings.cssMode ? 'true' : 'false'}
        breakpoints={`{"768": {"slidesPerView": ${
          carouselSettings?.slidesPerView?.md || 1
        }}, "1024": {"slidesPerView": ${
          carouselSettings?.slidesPerView?.lg || 1
        }}}`}
        {...(carouselSettings?.loop ? { loop: 'true' } : {})}
        {...(carouselSettings?.autoplay
          ? {
              'autoplay-delay': carouselSettings.autoplay.delay,
              'autoplay-disable-on-interaction':
                carouselSettings.autoplay.disableOnInteraction === true
                  ? 'true'
                  : 'false',
            }
          : {})}
        {...(carouselSettings?.pagination
          ? {
              pagination: 'true',
              'pagination-type': carouselSettings.pagination.type,
              'pagination-clickable': carouselSettings.pagination.clickable,
            }
          : {})}
        {...(carouselSettings?.spaceBetween
          ? {
              'space-between': carouselSettings.spaceBetween,
            }
          : {})}
      >
        {children}
      </swiper-container>
    </div>
  );
}
